import React, { useMemo } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenu } from 'ui-components/components/dropdown-menu/';

import Global from '../../../../../../store/global-selectors';
import messages from '../../messages';

const AccountSelector = ({ providerId = 0, className = '', sellerProviderId, onChange }) => {
  const sellerLabelProviders = useSelector(Global.selectSellerLabelProviders);
  const availableSellerLabelProviders = useMemo(() => {
    return sellerLabelProviders.filter((s) => s.labelProviderId === providerId);
  }, [sellerLabelProviders, providerId]);

  if (availableSellerLabelProviders.length < 2) {
    return null;
  }
  const defaultText = <FormattedMessage {...messages.accountSelectorDefault} />;
  const selectedProvider = sellerLabelProviders.find((s) => parseInt(s.sellerLabelProviderId, 10) === sellerProviderId);
  const displayText = selectedProvider ? selectedProvider.name : defaultText;

  return (
    <div className={className}>
      <DropdownMenu>
        <DropdownMenuToggler theme='link'>{displayText}</DropdownMenuToggler>
        {availableSellerLabelProviders.map((sellerProvider) => {
          return (
            <DropdownMenuItem
              key={`${sellerProvider.labelProviderID}_${sellerProvider.sellerLabelProviderId}`}
              className='dropdown-option'
              onClick={() => {
                onChange(parseInt(sellerProvider.sellerLabelProviderId, 10));
              }}
            >
              {sellerProvider.name}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenu>
    </div>
  );
};

AccountSelector.propTypes = {
  providerId: PropTypes.number,
  sellerProviderId: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default AccountSelector;
